import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { checkPayment } from '../../api/checkPayment';

export const useCheckPayment = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: checkPayment,

        onError: (data) => {
            navigate('/acquiring/fail');
        },
    });
};
